const E = "xsmall", l = "small", s = "medium", a = "large", _ = "xlarge", A = {
  xsmall: E,
  small: l,
  medium: s,
  large: a,
  xlarge: _
};
export {
  A as default
};
